import { BaseSyntheticEvent, useEffect, useState } from "react";
import { FieldValues, SubmitHandler, SubmitErrorHandler } from "react-hook-form";
import SubmitButton from "../../components/forms/SubmitButton";
import BBContainer from "./BBContainer";
import BBRegister from "./BBRegister";
import MyBBStatus from "./MyBBStatus";
import Wait from "../../components/elements/Wait";
import RequestClass from "../../classes/RequestClass";
import { requestState } from "../../components/types/custom";
import BBRegisterList from "./BBRegisterList";
import { IBBApi } from "../../interfaces/IBB";

type myBBTabType = "LIST" | "ADD";

const MyBB = () => {
    const [tab, setTab] = useState("LIST" as myBBTabType);
    const [bbAPI, setBBApi] = useState({} as IBBApi);
    const [notification, setNotification] = useState<JSX.Element | String>();

    /* czy wymagane zapytanie do API */
    // const [apiRequired, setApiRequired] = useState(true);
    /* czy odebrane zapytanie z API */
    const [apiReadState, setApiReadState] = useState("None" as requestState);

    useEffect(() => {
        const err_callback = (result: any) => {
            setNotification(RequestClass.errorAlert(result));
            // if (setIsUserInfoRead)
            //     setIsUserInfoRead(true)

            setApiReadState("Error");
        };
        const succ_callback = (result: any) => {
            // setNotification(RequestClass.errorAlert(result));
            // if (setIsUserInfoRead)
            //     setIsUserInfoRead(true)
            // console.log("--");
            // console.log(result.participants);
            // console.log(bbAPI.participants);
            // console.log(result);
            setBBApi({ ...bbAPI, participants: result.participants, products: result.products });

            //bbAPI.participants = result.participants;
            // console.log(result);

            setApiReadState("OK");
        };
        if (apiReadState === "None") {
            /* wysyłam zapytanie do API */
            setApiReadState("Progress");
            RequestClass.makeRequest("bb/", null, succ_callback, err_callback);
        }
    }, [apiReadState]);

    /*  ****************************************************************** */
    function myList() {
        return (
            <>
                <BBRegisterList bbApi={bbAPI} />
                <div className="mt-5" onClick={() => setTab("ADD")}>
                    <button className="button  has-background-primary-light mt-4">
                        {bbAPI.participants !== undefined && bbAPI.participants.length > 1
                            ? "Zapisz kolejnego uczestnika na Bieg Belfrów"
                            : "Zapisz się na Bieg Belfrów"}
                    </button>
                </div>
            </>
        );
    }

    /*  ****************************************************************** */
    function myAdd() {
        return (
            <>
                <BBRegister
                    bbApi={bbAPI}
                    success_callback={(message) => {
                        setTab("LIST");
                        setNotification(
                            RequestClass.succAlert("Dziękujemy!", <div>Uczestnik został dodany do listy. Niezapomnij opłacić opłaty startowej.</div>)
                        );
                        /* wymuzam nowe pobranie uczestników */
                        setApiReadState("None");
                    }}
                />
            </>
        );
    }

    /*  ****************************************************************** */
    if (apiReadState === "Progress" || apiReadState === "Error") {
        return (
            <BBContainer>
                {notification ? (
                    <>
                        <div className="mt-5" onClick={() => setApiReadState("None")}>
                            <button className="button  mt-4 is-warning">Spóbuj ponownie</button>
                        </div>
                    </>
                ) : (
                    <Wait></Wait>
                )}
                {notification}
            </BBContainer>
        );
    }
    return (
        <>
            <BBContainer>
                {notification}
                {/* <MyBBStatus /> */}
                {tab === "LIST" && myList()}
                {tab === "ADD" && myAdd()}
                <div className="mt-5">{/* <button className="button is-primary mt-4">Zapisz się na 5 edycję Biegu Belfra</button> */}</div>
            </BBContainer>
        </>
    );
};

export default MyBB;
